/** Shared nav-item definitions and live badge counts for Sidebar and MobileNav. */

import { alertsQuery, basketsQuery, tokensQuery } from "@client/lib/queries";
import { useQuery } from "@tanstack/react-query";

export type NavItem = {
  readonly to: string;
  readonly label: string;
  readonly icon: string;
  readonly exact?: boolean;
  readonly badge?: number | null;
  readonly badgeRed?: boolean;
};

export const NAV_ICONS = {
  pulpit: "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z",
  watch: "M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01",
  basket: "M8 3v18M16 3v18M8 8h8M8 13h8M8 18h8",
  journal: "M4 4h12a2 2 0 0 1 2 2v14H6a2 2 0 0 1-2-2zM4 18a2 2 0 0 1 2-2h12",
  bell: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10 21a2 2 0 0 0 4 0",
  compass: "M12 2a10 10 0 1 0 0.01 0ZM16 8l-2.5 6-6 2.5 2.5-6z",
  settings:
    "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
};

export function useNavItems(): NavItem[] {
  const tokensQ = useQuery(tokensQuery());
  const basketsQ = useQuery(basketsQuery());
  const alertsQ = useQuery(alertsQuery());

  const tokens = tokensQ.data ?? [];
  const baskets = basketsQ.data ?? [];
  const alerts = alertsQ.data ?? [];
  const openBaskets = baskets.filter((b) => b.status !== "closed");
  const firedAlertsCount = alerts.filter((a) => a.active && !a.armed).length;

  return [
    { to: "/", label: "Pulpit", icon: NAV_ICONS.pulpit, exact: true },
    {
      to: "/watchlista",
      label: "Watchlista",
      icon: NAV_ICONS.watch,
      badge: tokensQ.data ? tokens.length : null,
    },
    { to: "/sektory", label: "Sektory", icon: NAV_ICONS.compass },
    {
      to: "/koszyki",
      label: "Koszyki",
      icon: NAV_ICONS.basket,
      badge: basketsQ.data ? openBaskets.length : null,
    },
    { to: "/dziennik", label: "Dziennik", icon: NAV_ICONS.journal },
    {
      to: "/alerty",
      label: "Alerty",
      icon: NAV_ICONS.bell,
      badge: firedAlertsCount > 0 ? firedAlertsCount : null,
      badgeRed: true,
    },
    { to: "/ustawienia", label: "Ustawienia", icon: NAV_ICONS.settings },
  ];
}
